var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fs-pill",
    _vm._g(
      _vm._b(
        {
          attrs: {
            color: _vm.color,
            counter: _vm.counter,
            fixed: _vm.fixed,
            size: _vm.size,
            tag: _vm.tag,
            "hover-mode": _vm.hoverMode,
          },
        },
        "fs-pill",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }